import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import helper from "../../utils/helper";
import moment from "moment";
const HeaderCalendar = ({ value, type, onChange, onTypeChange , minDate = null, maxDate = null }) => {
  const start = 0;
  const end = 12;
  const current = value.clone();
  const localeData = value.localeData();
  const months = [];
  for (let i = 0; i < 12; i++) {
    current.month(i);
    months.push(localeData.months(current));
  }
  const month = value.month();
  // const year = value.year();
  const year = moment(value).format('YYYY');
  let months_name = "";
  for (let index = start; index < end; index++) {
    if (index === month) {
      months_name = months[index];
      // months_name = helper.CONFIG.MONTH[ index == 0 ? 12 : index ]
    }
  }

  return <>
    <div className="header-calendar">
      {
        helper.TIME.disableDate(moment(value.clone()).add(-1, 'months'), minDate) == false 
        ?
        <div className="calen-arrow "
          onClick={() => {
            const current = value.clone();
            const now = current.add(-1, "months");
            onChange(now);
          }}
        >
          <FiChevronLeft size={24} style={{ color: "#444c63" }}/>
        </div>
        : <div style={{ width: 24, height: 28.80 }}> </div>
      }
      <div className="calen-header-text">{helper.CONFIG.MONTH_ENTOTH[months_name]} {year}</div>
      {
        helper.TIME.disableDate(moment(value.clone()).add(1, 'months'), null, maxDate) == false  
        ?
        <div className="calen-arrow "
          onClick={() => {
            const current = value.clone();
            const now = current.add(1, "months");
            onChange(now);
          }}
        >
          <FiChevronRight size={24} style={{ color: "#444c63" }}/>
        </div>
        : <div style={{ width: 24, height: 28.80 }}> </div>
      }
    </div>
  </>;
};
export default HeaderCalendar;
